"use client";

import { lazyComponent } from "@/components/ui/lazy-component";
import { LoadFailureNotice } from "@/components/ui/load-failure-notice";
import type { RfqWizardProps } from "@/components/rfq/wizard/rfq-wizard";

export function LoadingStep() {
  return (
    <p role="status" className="p-6 text-muted-foreground">
      Loading your next step…
    </p>
  );
}

export const PublicRfqWizard = lazyComponent(
  async () => {
    const [{ PublicConvexProvider }, { RfqWizard: Wizard }] = await Promise.all(
      [
        import("@/components/providers/public-convex-provider"),
        import("@/components/rfq/wizard/rfq-wizard"),
      ],
    );
    return function PublicQuoteWizard(props: RfqWizardProps) {
      return (
        <PublicConvexProvider>
          <Wizard {...props} />
        </PublicConvexProvider>
      );
    };
  },
  {
    loading: <LoadingStep />,
    failure: {
      label: "public-rfq-wizard",
      fallback: <LoadFailureNotice title="The quote form could not load." />,
    },
  },
);

export const PublicListingWizard = lazyComponent(
  () =>
    import("@/components/product/public-wizard-inner").then(
      (module) => module.PublicWizardInner,
    ),
  {
    loading: <LoadingStep />,
    failure: {
      label: "public-listing-wizard",
      fallback: <LoadFailureNotice title="The listing form could not load." />,
    },
  },
);
